import { render, staticRenderFns } from "./TempAccountChangeStatus.vue?vue&type=template&id=9041ed84"
import script from "./TempAccountChangeStatus.vue?vue&type=script&lang=ts"
export * from "./TempAccountChangeStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports